import api from "../services/index";

const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    verifyOtp: builder.mutation({
      query: (body) => ({
        url: `/api/auth/verifyotp`,
        method: "POST",
        body: {
          emailId: body.emailId,
          employeeId: body.employeeId,
        },
        params: {
          otp: body.otp,
        },
      }),
    }),
    sendOtp: builder.mutation({
      query: (body) => ({
        url: `/api/auth/sendotp`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export default authApi;
export const { useSendOtpMutation, useVerifyOtpMutation } = authApi;
